/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {OrganizationFormComponent as ɵb} from './organization-form/organization-form.component';
export {declaration as ɵa} from './organization.module';
export {OrganizationRoutes as ɵc} from './organization.routing';